(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        const slideDownElement = document.getElementsByClassName('slideDown')[0];

        if(!slideDownElement) return;

        const triggerHandle = slideDownElement ? slideDownElement.dataset.slideDownTrigger : null;

        if(!triggerHandle) return;

        const triggerElement = triggerHandle ? document.querySelector(triggerHandle) : null;

        if(!triggerElement) return;
        
        function slideDownHandler() {

            const triggerElementBounds = triggerElement.getBoundingClientRect();
            const triggerElementPositionBottom = triggerElementBounds.bottom;

            if(triggerElementPositionBottom < 0) {
                slideDownElement.classList.add('down');
            } else {
                slideDownElement.classList.remove('down');
            }
        }
        if (triggerElement) {
            window.addEventListener('scroll', slideDownHandler);
            slideDownHandler();
        }
    });
})();